import React from 'react'
import Navbar from './Navbar'
import HeroSection from './HeroSection'
import WhySection from './WhySection'
import HearFromTeam from './HearFromTeam'
import Transform from './Transform'
import Footer from './Footer'

const Landing = () => {
    return (
        <div>
            
            <div className='mx-4 sm:mx-8 md:mx-16 lg:mx-[6.88rem]'>
                
                <div className='flex flex-col gap-12 sm:gap-16 md:gap-20 lg:gap-[5.94rem]'>
                    <Navbar />
                    <HeroSection />
                </div>
            </div>
            <WhySection />
            <HearFromTeam/>
            <Transform/>
            <Footer/>
        </div>
    )
}

export default Landing